export default __webpack_public_path__ + "static/media/divider_v.dcfa5391.svg";